import { Map, Layer, LngLat } from 'mapbox-gl';

export function addLayer(map:Map, layer:Layer) {
	

	const layers = map.getStyle().layers as Layer[];
	// Find the index of the first symbol layer in the map style
	let firstSymbolId;
	for (let i = layers.length-2; i >= 0; i--) {
		if (layers[i].type != 'symbol') {
			firstSymbolId = layers[i+1].id;
			break;
		}
	}


	//remove old layer for hot reloading to work
	const oldLayer = map.getLayer(layer.id);
	if(module.hot) {
		if(oldLayer)
			map.removeLayer(layer.id);
	}
	map.addLayer(layer, firstSymbolId);
}


export function pixelDistance(pos1:LngLat, pos2:LngLat, map:Map):number {
	const px1 = map.project(pos1);
	const px2 = map.project(pos2);
	return px1.dist(px2);
}